"use client";
import React, { useEffect } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";
import InnerBanner from "@/components/InnerBanner";
import Calculator from "@/components/calculator/Calculator";
import UsingCalculator from "@/components/calculator/UsingCalculator";
import useSplitTextAnimation from "@/components/hooks/useSplitTextAnimation";
import CalculatorNew from "@/components/calculator/CalculatorNew";

// gsap.registerPlugin(SplitText);

const AllCalculator = ({ data,stockData, total }) => {
  const banner = data?.[0]?.banner;
  const overview = data?.[0]?.overview;


  useSplitTextAnimation(".split-up", [data]);

  return (
    <StyledComponent>
      <CalculatorNew stock={stockData} total={total}/>
      <UsingCalculator data={overview} />
    </StyledComponent>
  );
};

const StyledComponent = styled.section``;

export default AllCalculator;
